<template>
  <v-container id="painel" fill-height fluid grid-list-xl tag="section">
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <!-- <v-card class="justify-center" fill-height fluid grid-list-xl > -->
        <v-card>
          <v-app-bar color="#34a95a" dark dense>
            <v-btn icon>
              <v-icon>mdi-desktop-mac-dashboard</v-icon>
            </v-btn>
            <div class="d-flex align-center">
              <h3>Painel | Analítico</h3>
            </div>
          </v-app-bar>
          <!-- Snack bar -->
          <div class="text-center ma-2">
            <v-snackbar
              v-model="snackbar"
              :color="snackbarColor"
              :timeout="timeout"
              top
            >
              {{ textSnackbar }}
              <v-btn
                class="mx-2"
                fab
                small
                color="white"
                text
                @click="snackbar = false"
                dark
              >
                <v-icon dark>mdi-close-thick</v-icon>
              </v-btn>
            </v-snackbar>
          </div>

          <filtro-painel v-on:add-filtro-painel="consultarDadosApi">
          </filtro-painel>
          <v-card v-if="dataSinteseFaturamento.length">
            <GChart
              :type="typeChartValor"
              :data="dataGraficoValor"
              :options="optionsChartValor"
            >
            </GChart>
            <GChart
              :type="typeChartQuantidade"
              :data="dataGraficoQuantidade"
              :options="optionsChartQuantidade"
            >
            </GChart>
            <GChart
              :type="typeChartTicket"
              :data="dataGraficoTicket"
              :options="optionsChartTicket"
            >
            </GChart>
          </v-card>
          <v-card v-if="dataSinteseFaturamento.length">
            <v-card-title class="justify-center">Síntese</v-card-title>
            <v-data-table
              :headers="headersSinteseFaturamento"
              :items="dataSinteseFaturamento"
              :items-per-page="24"
              class="elevation-1"
              dense
            >
              <!-- Tempalte Header -->
              <template v-slot:[`header.hora`]="{ header }">
                <v-chip class="ma-2" color="warning" dark small>
                  <v-avatar>
                    <v-icon>mdi-clock</v-icon>
                  </v-avatar>
                  {{ header.text }}
                </v-chip>
              </template>
              <template v-slot:[`header.qtde_orcamentos`]="{ header }">
                <v-chip class="ma-2" color="#008000" dark small>
                  {{ header.text }}
                </v-chip>
              </template>
              <template v-slot:[`header.percentualOrcamentosQtde`]="{ header }">
                <v-chip class="ma-2" color="#008000" dark small>
                  <v-avatar>
                    <v-icon>mdi-label-percent</v-icon>
                  </v-avatar>
                  {{ header.text }}
                </v-chip>
              </template>
              <template v-slot:[`header.valor_orcamentos`]="{ header }">
                <v-chip class="ma-2" color="#008000" dark small>
                  {{ header.text }}
                </v-chip>
              </template>
              <template
                v-slot:[`header.percentualOrcamentosValor`]="{ header }"
              >
                <v-chip class="ma-2" color="#008000" dark small>
                  <v-avatar>
                    <v-icon>mdi-label-percent</v-icon>
                  </v-avatar>
                  {{ header.text }}
                </v-chip>
              </template>
              <template v-slot:[`header.ticketOrcamentos`]="{ header }">
                <v-chip class="ma-2" color="#008000" dark small>
                  {{ header.text }}
                </v-chip>
              </template>

              <template v-slot:[`header.qtde_requisicoes`]="{ header }">
                <v-chip class="ma-2" color="#2196F3" dark small>
                  {{ header.text }}
                </v-chip>
              </template>
              <template
                v-slot:[`header.percentualRequisicoesQtde`]="{ header }"
              >
                <v-chip class="ma-2" color="#2196F3" dark small>
                  <v-avatar>
                    <v-icon>mdi-label-percent</v-icon>
                  </v-avatar>
                  {{ header.text }}
                </v-chip>
              </template>
              <template v-slot:[`header.valor_requisicoes`]="{ header }">
                <v-chip class="ma-2" color="#2196F3" dark small>
                  {{ header.text }}
                </v-chip>
              </template>
              <template
                v-slot:[`header.percentualRequisicoesValor`]="{ header }"
              >
                <v-chip class="ma-2" color="#2196F3" dark small>
                  <v-avatar>
                    <v-icon>mdi-label-percent</v-icon>
                  </v-avatar>
                  {{ header.text }}
                </v-chip>
              </template>
              <template v-slot:[`header.ticketRequisicoes`]="{ header }">
                <v-chip class="ma-2" color="#2196F3" dark small>
                  {{ header.text }}
                </v-chip>
              </template>

              <!-- Template table -->
              <template v-slot:[`item.percentualOrcamentosQtde`]="{ item }">
                <div v-if="item.percentualOrcamentosQtde">
                  {{ item.percentualOrcamentosQtde }} %
                </div>
              </template>
              <template v-slot:[`item.valor_orcamentos`]="{ item }">{{
                item.valor_orcamentos | dinheiro
              }}</template>
              <template v-slot:[`item.percentualOrcamentosValor`]="{ item }">
                <div v-if="item.percentualOrcamentosValor">
                  {{ item.percentualOrcamentosValor }} %
                </div></template
              >
              <template v-slot:[`item.ticketOrcamentos`]="{ item }">{{
                item.ticketOrcamentos | dinheiro
              }}</template>
              <template v-slot:[`item.percentualRequisicoesQtde`]="{ item }">
                <div v-if="item.percentualRequisicoesQtde">
                  {{ item.percentualRequisicoesQtde }} %
                </div></template
              >
              <template v-slot:[`item.valor_requisicoes`]="{ item }">{{
                item.valor_requisicoes | dinheiro
              }}</template>
              <template v-slot:[`item.percentualRequisicoesValor`]="{ item }">
                <div v-if="item.percentualRequisicoesValor">
                  {{ item.percentualRequisicoesValor }} %
                </div></template
              >
              <template v-slot:[`item.ticketRequisicoes`]="{ item }">{{
                item.ticketRequisicoes | dinheiro
              }}</template>
            </v-data-table>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FiltroPainel from "../../components/filtros/FiltroPainel";
import { GChart } from "vue-google-charts";

export default {
  components: {
    FiltroPainel,
    GChart,
  },
  data: () => ({
    //snackbar
    loading: false,
    errored: false,
    snackbar: false,
    textSnackbar: "",
    snackbarColor: "",
    timeout: 10000,
    // //dados
    dataGraficoValor: [],
    dataGraficoQuantidade: [],
    dataGraficoTicket: [],
    // dataTable
    dataSinteseFaturamento: [],
    headersSinteseFaturamento: [
      {
        text: "Hora",
        align: "center",
        sortable: false,
        value: "hora",
        class: "subtitle-2",
      },
      {
        text: "Qtde",
        align: "center",
        sortable: false,
        value: "qtde_orcamentos",
        class: "subtitle-2",
      },
      {
        text: "",
        align: "end",
        sortable: false,
        value: "percentualOrcamentosQtde",
        class: "subtitle-2",
      },
      {
        text: "Valor",
        align: "end",
        sortable: false,
        value: "valor_orcamentos",
        class: "subtitle-2",
      },
      {
        text: "",
        align: "end",
        sortable: false,
        value: "percentualOrcamentosValor",
        class: "subtitle-2",
      },
      {
        text: "Ticket",
        align: "end",
        sortable: false,
        value: "ticketOrcamentos",
        class: "subtitle-2",
      },
      {
        text: "Qtde",
        align: "center",
        sortable: false,
        value: "qtde_requisicoes",
        class: "subtitle-2",
      },
      {
        text: "",
        align: "end",
        sortable: false,
        value: "percentualRequisicoesQtde",
        class: "subtitle-2",
      },
      {
        text: "Valor",
        align: "end",
        sortable: false,
        value: "valor_requisicoes",
        class: "subtitle-2",
      },
      {
        text: "",
        align: "end",
        sortable: false,
        value: "percentualRequisicoesValor",
        class: "subtitle-2",
      },
      {
        text: "Ticket",
        align: "end",
        sortable: false,
        value: "ticketRequisicoes",
        class: "subtitle-2",
      },
    ],
    typeChartValor: "LineChart",
    optionsChartValor: {
      title: "Grupo | Hora | Valor",
      legend: { position: "bottom" },
      is3D: true,
      colors: ["#008000", "#2196F3"],
    },
    typeChartQuantidade: "LineChart",
    optionsChartQuantidade: {
      title: "Grupo | Hora | Quantidade",
      legend: { position: "bottom" },
      is3D: true,
      colors: ["#008000", "#2196F3"],
    },
    typeChartTicket: "LineChart",
    optionsChartTicket: {
      title: "Grupo | Hora | Ticket",
      legend: { position: "bottom" },
      is3D: true,
      colors: ["#008000", "#2196F3"],
    },
  }),
  methods: {
    consultarDadosApi(dados) {
      this.loading = true;
      this.$http
        .get("dashboard", {
          params: {
            dataInicial: dados.dataInicial,
            dataFinal: dados.dataFinal,
            filiais: dados.selectedLojas,
          },
        })
        .then((res) => {
          if (res.data.datatableSinteseFaturamento) {
            this.dataSinteseFaturamento = res.data.datatableSinteseFaturamento;
            this.dataGraficoQuantidade = res.data.dataGraficoQuantidade;
            this.dataGraficoValor = res.data.dataGraficoValor;
            this.dataGraficoTicket = res.data.dataGraficoTicket;
          } else {
            this.textSnackbar = "Não há dados para o período.";
            this.snackbar = true;
            this.snackbarColor = "info";
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 400) {
              this.textSnackbar = error.response.data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
</style>